import { BRANDING_CLASS_VALUES, BRANDING_CLASSES } from "./branding.ts";

/**
 * Utility class for detecting keys
 */
export class BrandingUtilities {
  /**
   * Returns true if you entered an existing branding class name e.g. link-color
   * @param {} className
   */
  static isBrandingClass = (className) => {
    return BRANDING_CLASS_VALUES.includes(className);
  };

  /**
   * Returns true if you entered a string containing any branding class name
   *   e.g. 'large-text foo-bar primary-color-foreground'
   * @param {} className
   */
  static hasBrandingClass = (classNames) => {
    if (!Array.isArray(classNames)) {
      classNames = classNames.split(" ");
    }
    return classNames.some((c) => BrandingUtilities.isBrandingClass(c));
  };

  /**
   * Inspects content and returns all classes that are missing.
   *
   *    * @param {} content - a big string
   */
  static getMissingClassesFromFile = (content) => {
    return BRANDING_CLASS_VALUES.filter(
      (v) => !content.match(`\\.${v}[\\s|:]`)
    );
  };

  static COBRANDED_PRIMARY_BUTTON_WITH_HOVER = [
    BRANDING_CLASSES.PRIMARY_COLOR_BACKGROUND,
    BRANDING_CLASSES.OFFSET_PRIMARY_COLOR_FOREGROUND,
    BRANDING_CLASSES.PRIMARY_COLOR_BACKGROUND_HOVER,
  ];

  static COBRANDED_DISABLED_BUTTON = [
    BRANDING_CLASSES.DISABLED_BACKGROUND,
    BRANDING_CLASSES.DISABLED_FOREGROUND,
  ];

  static DEFAULT_BUTTON = [
    BRANDING_CLASSES.BUTTON_DEFAULT_BACKGROUND,
    BRANDING_CLASSES.BUTTON_DEFAULT_TEXT,
  ];
}
